import { reducers } from '@wix/da-shared-react/pkg/redux/shared';
import profileHeroEditor from './profileHeroEditor';
import pagePrivileges from './pagePrivileges';
import profileOwner from './profileOwner';
import sections from './sections';
import gallectionSection from './gallectionSection';
import layout from './layout';
import pageLayout from './pageLayout';
import modules from './modules';
import statsSection from './statsSection';
import avatarEditor from './avatar';

const DEFAULT_ENVIRONMENT = {};

const rootReducers = {
  ...reducers,
  profileHeroEditor,
  pagePrivileges,
  profileOwner,
  sections,
  gallectionSection,
  environment: state => state || DEFAULT_ENVIRONMENT,
  layout,
  pageLayout,
  modules,
  statsSection,
  avatarEditor,
};

export default rootReducers;
